import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  weddingCode,
  getRSVPMarriageDetail,
  getCouple,
  setCouple,
} from "./Api";

// ? Initial State
export const initialState = {
};

// Async thunk action for user login

export const getCoupleDetails = createAsyncThunk(
  "marriageSlice/getCoupleDetails",
  async () => {
    const response = await getCouple();
    return response.data;
  }
);
export const setCoupleDetails = createAsyncThunk(
  "marriageSlice/setCoupleDetails",
  async (data) => {
    const response = await setCouple(data);
    return response.data;
  }
);

export const getRSVPMarriageDetails = createAsyncThunk(
  "marriageSlice/getRSVPMarriageDetails",
  async (rsvpCode) => {
    const response = await getRSVPMarriageDetail(rsvpCode);
    return response.data;
  }
);

export const WeddingWebsiteCode = createAsyncThunk(
  "WeddingWebsite/WeddingWebsiteCode",
  async (code) => {
    const response = await weddingCode(code);
    return response.data;
  }
);

const marriageSlice = createSlice({
  name: "marriage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //  ? OTP FOR WEDDING WEBSITE
      .addCase(WeddingWebsiteCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(WeddingWebsiteCode.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.weddingCeremonies = action.payload;
      })
      .addCase(WeddingWebsiteCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error;
      });
  },
});

// Export the actions and reducer
export default marriageSlice.reducer;
